const getGroupLessonNote = (groupLessonNotes, lesson) => {
  return groupLessonNotes.find(groupLessonNote => groupLessonNote.lesson_id === lesson.id) || null
}

export default getGroupLessonNote
